import { Context } from '@nuxt/types'
import { KintellCardMessage } from '@/lib/broadcasting/messages'

export default (ctx: Context) => {
  return (message: KintellCardMessage) => {
    const card = ctx.store.getters['kintellCards/activeKintellCard']
    const user = ctx.store.getters['kintellCards/activeUser']

    const activeBooking = ctx.store.getters['myKintell/activeBooking']

    if (message.kintellCard.id !== card.id || activeBooking) {
      return
    }

    ctx.$toast.error(user.fullName + ' has unpublished their Kintell Card "' + card.title + '" .', {
      duration: 10000
    })
    card.removeFromVuex()
    ctx.redirect('/')
  }
}
